import Cookies from 'js-cookie'
import React, { useEffect } from 'react'
import { useAuth } from '~/hooks/useAuth'
import { useDeviceInfo } from '~/hooks/useDeviceInfo'
import { USER_DEVICE_KEY } from '~/configs'

export const UserDeviceProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { handleSendDeviceInfo } = useDeviceInfo()
  const { isLogin } = useAuth()
  useEffect(() => {
    if (isLogin && Cookies.get(USER_DEVICE_KEY) !== 'true') {
      handleSendDeviceInfo()
    }
  }, [])
  return <>{children}</>
}
